var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"callback-fixed"},[_c('a',{staticClass:"js-popup js-request",attrs:{"data-mfp-decor":"mfp-product","href":"#popup-request","data-popup":"callback"},on:{"click":_vm.onOpenRequestCallModal}},[_c('img',{attrs:{"alt":"Заказать обратный звонок","src":"/img/obratny-zvonok.png"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }